import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RenewalCard } from '../../models/renewal-card';
import { ConfirmEmployerCard } from '../../models/renewal-confirm-employer-card';
import { Router, ActivatedRoute } from '@angular/router';
import { RenewalCogService } from '../../../services/renewalcog.service';
import { ErrorService } from '../../../services/error.service'
import { AccountService } from '../../../services/account.service'
import { ApplicationDataService } from '../../../services/application.service';
import { RenewalPlan } from 'app/models/renewal-plan';

@Component({
  selector: 'app-renewal-dashboard-cog',
  templateUrl: './renewal-dashboard-cog.component.html',
  styleUrls: ['./renewal-dashboard-cog.component.css']
})
export class RenewalDashboardCogComponent implements OnInit {

  errorMessage: string = null;
  renewals: RenewalCard[] = [];
  employerConfirmation: ConfirmEmployerCard[] = [];

  constructor(private router: Router, private route: ActivatedRoute, private accountService: AccountService, private renewalCogService: RenewalCogService, private errorService: ErrorService,
    private applicationService: ApplicationDataService) {

    localStorage.removeItem('RenewalKey');

    this.renewalCogService.getRenewalsForDashboard()
      .subscribe(res => this.onGetRenewalsForDashboard(res), res => this.renewalCogService.handleError("Error pulling renewal records."));
  }

  ngOnInit() {
    this.getResidentStatus();
  }

  getResidentStatus() {
    this.accountService.getResidentStatus()
      .subscribe(res => this.onGetResidentStatusSuccess(res), err => this.accountService.handleError(err));
  }
  onGetResidentStatusSuccess(res) {
    if (!res) {
      this.router.navigate(['/application/dashboard']);
    }
  }

  async onGetRenewalsForDashboard(returnedRenewals: RenewalCard[]) {

    if (returnedRenewals.length > 0) {
      for (const element of returnedRenewals) {
        let prop = await this.applicationService.getProperty(element.YardiKey).toPromise();
        element.PropViewCard = { ...prop.results[0], sqft: `${prop.results[0].sqft}` };
        element.PropViewCard.sqft = element.PropViewCard.sqft.toLocaleString();
        element.PropViewCard.rent = element.Rent.toLocaleString();
        if (element.Plans) {
          element.Plans = element.Plans.map(p => new RenewalPlan(p.LeaseRenewalPlanKey, p.NewRent, p.RenewalLeaseTerm, null, null, p.Title));
        }
        this.setDisplayStatus(element);
      }
      this.renewals = returnedRenewals;
    }
    else {
      this.renewalCogService.getEmployerConfirmationForDashboard()
        .subscribe(res => this.onGetEmployerConfirmationDashboard(res), res => this.renewalCogService.handleError("Error pulling renewal records."));
    }
  }

  setDisplayStatus(renewalCard) {
    if (renewalCard.Status === "Offer Sent To Resident") {
      if (renewalCard.ChosenPlanName) {
        renewalCard.displayStatus = `Plan Selected: ${renewalCard.ChosenPlanName}`;
      } else {
        renewalCard.displayStatus = "Select a Plan"
      }
    } else {
      renewalCard.displayStatus = renewalCard.Status;
    }
  }

  onGetEmployerConfirmationDashboard(employerConfirmationList: ConfirmEmployerCard[]) {
    if (employerConfirmationList.length > 0) {
      this.employerConfirmation.push(employerConfirmationList[0]);
    }
  }

  continueRenewal(card: RenewalCard) {
    localStorage.setItem('RenewalKey', card.LeaseRenewalKey.toString());
    localStorage.setItem('YardiKey', card.YardiKey);
    location.href = '/renewalcog/renewal-review/contact-info';
  }

  confirmEmployer(card: ConfirmEmployerCard) {

    localStorage.setItem('RenewalKey', card.LeaseRenewalKey.toString());
    localStorage.setItem('YardiKey', card.YardiKey);

    location.href = '/renewalcog/renewal-review/confirm-employer';
  }


}
